import { render, staticRenderFns } from "./courtBulletinList.vue?vue&type=template&id=d10628f6&scoped=true"
import script from "./courtBulletinList.vue?vue&type=script&lang=js"
export * from "./courtBulletinList.vue?vue&type=script&lang=js"
import style0 from "./courtBulletinList.vue?vue&type=style&index=0&id=d10628f6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d10628f6",
  null
  
)

export default component.exports